// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"194": "__federation_expose_ScribeSettings","615": "__federation_expose_Scribe",}[chunkId] || chunkId) + "." + {"194": "cc9f9e47","396": "be932586","531": "b6d5624c","615": "b532579f","650": "2b6ea00a","672": "a6d32b8b","75": "5628f622","971": "33061a75","991": "9746022b",}[chunkId] + ".js"
}